/**
 * Classe base para todos os fields.
 * @author: Adalto Junior
 * Date: 20/09/13
 * Time: 11:47
 */


Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.DecimalRateKm = (function () {

    function DecimalRateKm() {

        Monet.UI.Fields.Decimal.apply (this, arguments);

        this.getValue = function () {

            var value = this.input.value;

            if (value) {

                var formatter = new Monet.Format.DECIMAL_RATE_KM(value).parseFloat();

                if(Monet.Session.User.unitSystem === 'NON_METRIC') {
                    formatter.convertFromNonMetric();
                }

                return formatter.getValue();
            }

            return value;

        };

        this.setValueView = function (){
            var value = this.value;
            if (this.input && (value || value === 0)) {

                var formatter = new Monet.Format.DECIMAL_RATE_KM(value);

                if(Monet.Session.User.unitSystem === 'NON_METRIC') {
                    formatter.convertToNonMetric();
                }

                this.input.value = formatter.format().getValue();
            }
        };

    }

    return DecimalRateKm;

}());